/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        notification: {
            display: 'inline-flex',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            right: 0,
            minWidth: 5,
            height: 5,
            color: 'black',
            fontSize: 'xs',
            fontWeight: 'medium',
            backgroundColor: 'yellow.400',
            border: '1px solid',
            borderColor: 'white',
            borderRadius: 'full'
        }
    }
}
